import { render } from "./ListePrivilegePage.vue?vue&type=template&id=51eea4de&ts=true"
import script from "./ListePrivilegePage.vue?vue&type=script&lang=ts"
export * from "./ListePrivilegePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__